export const PAYMENT_PROTECTION_INSURANCE_LINKS = {
  productFactSheet: 'https://www.solidab.se/villkor/lankar/SE/Trygghet/Produktblad_Fairlo.pdf',
  prePostPurchaseInfo: 'https://www.solidab.se/villkor/lankar/SE/Trygghet/FoE_Fairlo.pdf',
  insuranceMediationInfo:
    'https://www.solidab.se/villkor/lankar/SE/Trygghet/Forsakringsformedling_Fairlo.pdf',
  fullTerms: 'https://www.solidab.se/villkor/lankar/SE/Trygghet/Villkor_Fairlo.pdf',
} as const;
